import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Avatar, Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

type UserProfileBlockProps = {
  name: string;
  email: string;
  avatarUrl?: string;
};

const UserProfileBlock: React.FC<UserProfileBlockProps> = ({
  name,
  email,
  avatarUrl,
}) => {
  const navigate = useNavigate();

  const initials = name
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const openProfile = () => navigate("/profile");

  return (
    <Box
      role="button"
      tabIndex={0}
      aria-label="Open profile"
      onClick={openProfile}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openProfile();
        }
      }}
      sx={{
        borderTop: "1px solid rgba(255,255,255,0.2)",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2.25,
        py: 1.5,
        mt: 2,
        borderRadius: 2,
        cursor: "pointer",
        "&:focus-visible": {
          outline: "2px solid rgba(93,141,245,0.8)",
          outlineOffset: 2,
        },
      }}
    >
      <Avatar
        alt={name}
        src={avatarUrl}
        sx={{ width: 34, height: 34, fontSize: 12, flexShrink: 0 }}
      >
        {initials || <PersonOutlineIcon sx={{ fontSize: 18 }} />}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "white", lineHeight: 1.3 }}>
          {name}
        </Typography>
        <Typography
          sx={{
            fontSize: "11px",
            color: "rgba(255,255,255,0.7)",
            lineHeight: 1.35,
            wordBreak: "break-all",
          }}
        >
          {email}
        </Typography>
      </Box>
    </Box>
  );
};

export default UserProfileBlock;
